import React from 'react';
import { Editor as TinyMCE } from '@tinymce/tinymce-react';
import MarkdownIt from 'markdown-it';
import TurndownService from 'turndown';

const mdToHTML = new MarkdownIt({
  html: true,
  breaks: true,
});
const htmlToMD = new TurndownService();
htmlToMD.render = htmlToMD.turndown;

import css from './styles.module.scss';

function Editor (props) {
  const editorRef = React.useRef(null);
  const [defaultValueState, setDefaultValue] = React.useState('');
  const [prepared, setPrepared] = React.useState(false);

  const {
    className = "",
    children,
    onChange,
    defaultValue,
    value = "",
    name,
    menu = true,
    icons = false,
    height = 250,
    resize = true,
    ...other
  } = props;

  React.useEffect(_ => {
    if (!value || prepared) {
      return;
    }
    const theDefaultValue = defaultValue || value || '';
    setDefaultValue(mdToHTML.render(theDefaultValue));
    setPrepared(true);
  }, [value]);

  return <div
    className={`${css["molecule__editor-container"]} ${className}`}
    data-menu={menu ? 1 : null}
    data-icons={icons ? 1 : null}
    data-draggable="1"
    style={{height: height}}
    {...other}
  >
    <TinyMCE
      tinymceScriptSrc="/tinymce/tinymce.min.js"
      onInit={(evt, editor) => editorRef.current = editor}
      initialValue={defaultValueState}
      init={{
        height,
        resize,
        menubar: 'edit insert view format table tools help',
        plugins: [
          'advlist',
          'autolink',
          'lists',
          'link',
          'image',
          // 'charmap',
          // 'print',
          'preview',
          'anchor',
          'searchreplace',
          // 'visualblocks',
          'fullscreen',
          // 'insertdatetime',
          'table',
          'codesample',
          'media',
          // 'paste',
          'code',
          'help',
          'wordcount',
          // 'textpattern'
        ],
        toolbar: [
          'h1 h2 h3',
          '|',
          'bold italic underline strikethrough', // superscript subscript
          'blockquote',
          '|',
          'forecolor backcolor removeformat',
          '|',
          'alignleft aligncenter alignright', // 'alignjustify
          'bullist numlist link unlink',
          '|',
          'table',
          '|',
          `codesample code`, // styleselect formatselect
          'preview help',
        ].join(' ')
      }}
      onChange={event => {
        const target = {
          name,
          value: htmlToMD.render(editorRef.current.getContent())
        };
        onChange({
          ...event,
          target
        }, target);
      }}
    />
  </div>;
}

export default Editor;
